var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "radio-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "select-icon-wrapper __pointer",
        on: {
          click: function($event) {
            return _vm.toogleSelect(true)
          }
        }
      },
      [
        _c("span", {
          staticClass: "select-icon",
          class: {
            active: _vm.isSelect
          }
        }),
        _vm._v(_vm._s(_vm.$t("true")) + "\n    ")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "select-icon-wrapper __pointer",
        on: {
          click: function($event) {
            return _vm.toogleSelect(false)
          }
        }
      },
      [
        _c("span", {
          staticClass: "select-icon",
          class: {
            active: !_vm.isSelect
          }
        }),
        _vm._v(_vm._s(_vm.$t("false")) + "\n    ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }